import React from 'react'

interface FormulaIconProps {
  color?: string
  width?: number
  height?: number
  className?: string
}

const FormulaIcon: React.FC<FormulaIconProps> = ({
  color = 'currentColor',
  width = 24,
  height = 24,
  className,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      className={className}
    >
      <path
        fill={color}
        d='M5.52,6.87L4.71,7.79l0.08,0.35h2.1c-0.43,2.48-0.75,4.71-1.36,8.15c-0.73,4.39-1.16,5.47-1.41,5.86 c-0.22,0.39-0.54,0.59-0.96,0.59c-0.47,0-1.32-0.37-1.78-0.79c-0.16-0.11-0.36-0.08-0.56,0.05C0.4,22.35,0,22.88,0,23.36 c-0.02,0.65,0.84,1.21,1.67,1.21c0.73,0,1.8-0.46,2.93-1.53c1.54-1.46,2.7-3.47,3.66-7.8c0.62-2.77,0.91-4.57,1.35-7.1l2.6-0.24 l0.56-1.03H9.84c0.76-4.24,1.35-4.99,2.08-4.99c0.48,0,1.05,0.37,1.7,1.1c0.19,0.26,0.48,0.24,0.7,0.06 c0.37-0.22,0.83-0.78,0.86-1.3C15.19,0.7,14.52,0,13.36,0c-1.05,0-2.65,0.7-4,2.08C8.17,3.33,7.56,4.9,7.13,6.87H5.52L5.52,6.87z M13.85,10.07c0.81-1.08,1.29-1.43,1.54-1.43c0.26,0,0.46,0.25,0.91,1.68l0.76,2.44c-1.46,2.24-2.53,3.48-3.18,3.48 c-0.22,0-0.43-0.07-0.59-0.22c-0.15-0.15-0.32-0.28-0.48-0.28c-0.54,0-1.2,0.65-1.21,1.46c-0.01,0.82,0.56,1.41,1.32,1.41 c1.3,0,2.4-1.27,4.52-4.65l0.62,2.09c0.53,1.8,1.16,2.56,1.94,2.56c0.96,0,2.26-0.82,3.67-3.04l-0.59-0.68 c-0.85,1.02-1.41,1.5-1.75,1.5c-0.37,0-0.7-0.57-1.13-1.96l-0.91-2.95c0.54-0.79,1.06-1.45,1.53-1.98 c0.55-0.63,0.98-0.9,1.27-0.9c0.24,0,0.46,0.1,0.59,0.25c0.17,0.19,0.28,0.28,0.48,0.28c0.47,0,1.19-0.59,1.21-1.38 c0.02-0.73-0.43-1.35-1.21-1.35c-1.18,0-2.23,1.02-4.24,4.01l-0.41-1.28c-0.58-1.8-0.96-2.73-1.77-2.73 c-0.94,0-2.23,1.16-3.5,2.99L13.85,10.07L13.85,10.07z'
      />
    </svg>
  )
}

export default FormulaIcon
